import Commons from '../../../../Services/Common/Common';

/** getCodeInfo / SP_GetCode 혼용 대비 */
const getCodeValue = (codeList, groupCd, codeNm) => {
  const found = codeList?.find((f) => {
    const g = f.groupCd ?? f.GroupCd;
    const nm = f.codeNm ?? f.CodeNm;
    return g === groupCd && nm === codeNm;
  });
  return found?.code ?? found?.Code ?? '';
};

/**
 * 그리드 필드는 camelCase(menuId, menuNm, …). API JSON도 동일 키로 맞추면 별도 map 불필요.
 * SaveMenBasicU1/U2 Dapper: @MenuId, @MenuNm, …
 */
export const MEN_BASIC_Schema = {
  fieldsMenu: {
    menuId: { initial: '', label: '메뉴ID', required: 'Y' },
    menuNm: { initial: '', label: '메뉴명', required: 'Y' },
    menuTypeNm: { initial: '', label: '메뉴타입', required: 'Y' },
    menuUp: { initial: '', label: '상위메뉴', required: 'Y' },
    screenTypeNm: { initial: '', label: '메뉴스크린', required: 'Y' },
    seq: { initial: '', label: '순번' },
  },
  fieldsProgram: {
    proId: { initial: '', label: '프로그램ID', required: 'Y' },
    proContent: { initial: '', label: '프로그램 설명' },
  },
  mapper: {
    search1: {
      Params: (_, context) =>
        Commons.EncryptAES(context.params ?? '') || '',
    },
    search2: {
      MenuId: (_, context) =>
        Commons.EncryptAES(context.menuId ?? '') || '',
    },
    save1: {
      UserId: (_, context) => context.userInfo?.userid || '',
      MenuId: (row) =>
        Commons.EncryptAES(row.menuId ?? row.MenuId ?? '') || '',
      MenuNm: (row) =>
        Commons.EncryptAES(row.menuNm ?? row.MenuNm ?? '') || '',
      MenuType: (row, context) =>
        Commons.EncryptAES(
          getCodeValue(
            context.codeList,
            'MENU_TYPE',
            row.menuTypeNm ?? row.MenuTypeNm ?? ''
          )
        ) || '',
      MenuUp: (row) =>
        Commons.EncryptAES(row.menuUp ?? row.MenuUp ?? '') || '',
      ScreenType: (row, context) =>
        Commons.EncryptAES(
          getCodeValue(
            context.codeList,
            'SCREEN_TYPE',
            row.screenTypeNm ?? row.ScreenTypeNm ?? ''
          )
        ) || '',
      Seq: (row) =>
        Commons.EncryptAES(String(row.seq ?? row.Seq ?? '0')) || '',
    },
    save2: {
      UserId: (_, context) => context.userInfo?.userid || '',
      ProId: (row) =>
        Commons.EncryptAES(row.proId ?? row.ProId ?? '') || '',
      ProContent: (row) =>
        Commons.EncryptAES(row.proContent ?? row.ProContent ?? '') || '',
      MenuId: (_, context) =>
        Commons.EncryptAES(context.menuId ?? '') || '',
    },
    delete1: {
      MenuId: (row) =>
        Commons.EncryptAES(row.menuId ?? row.MenuId ?? '') || '',
    },
    delete2: {
      ProId: (row) =>
        Commons.EncryptAES(row.proId ?? row.ProId ?? '') || '',
    },
  },
};
